import script from "./BowlIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BowlIcon.vue?vue&type=script&setup=true&lang=js"

import "./BowlIcon.vue?vue&type=style&index=0&id=2761066f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2761066f"]])

export default __exports__